import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import { Info } from 'lucide-react';
import { DefaultSheet, SheetBody } from 'twyne-new.ui';

import { CodeEditor } from '@/components/CodeEditor';

import { useDashboardStore } from '../store';

import template from './embed';

const propTypes = {
  siteId: PropTypes.number,
};

export default function EmbedPathCode({ siteId }) {
  const { lists: { customFields: { items: customFields, useLoad: useLoadCustomFields } } } = useDashboardStore()
  const [extraFields, setExtraFields] = useState("")

  useLoadCustomFields()

  const parseFields = useCallback(fields => {
    let fieldsValue = ""
    for (const field of fields) {
      let val = null;
      if (field.type === 'input') {
        val = `'${field.name}'`;
      } else if (field.type === 'integer') {
        val = `'0'`
      } else if (field.type === 'boolean') {
        val = `('true' | 'false')`
      }

      fieldsValue += `      data.cf_${field.key} = ${val};\n`;
    }
    return fieldsValue
  }, [])

  useEffect(() => {
    async function loadFields() {
      const parsedFields = parseFields(customFields)
      setExtraFields(parsedFields)
    }

    loadFields()
  }, [customFields, parseFields, siteId])

  return <>
    <DefaultSheet
      title='Embeddable Path Code'
      trigger={<Info size={28} className='cursor-pointer twy-text-accent' />}
      contentProps={{ size: 'xl' }}
    >
      <SheetBody>
        <CodeEditor
          value={template(siteId, extraFields)}
          language="html"
          theme="textmate"
          width="100%"
          height="450px"
          editorProps={{ $blockScrolling: true }}
          wrapEnabled={true}
          focus={true}
        />
      </SheetBody>
    </DefaultSheet>
  </>
}

EmbedPathCode.propTypes = propTypes
EmbedPathCode.defaultProps = {}
